<template>
  <input
    :value="value"
    v-bind="$attrs"
    class="input-style"
    @keyup="onInput"
    @input="numberChk"
    :maxlength="maxLen"
    :placeholder="labelVal"
    :disabled="disabledType"
  />
</template>

<script>
export default {
  name: "InputPhone",
  props: {
    value: {                // 외부에서 전달받는 전화번호 문자열
      type: String,
      default: '',
    },
    label: {                // placeholder 혹은 라벨 텍스트
      type: String,
      default: '',
    },
    type: {                 // 입력값 검사 타입 (예: markingNum)
      type: String,
      default: '',
    },
    dashCheck: {            // 전화번호에 대시(-) 추가 여부 (현재 미활성)
      type: Boolean,
      default: true,
    },
    maxLen: {               // 최대 입력길이 (기본 13자)
      type: Number,
      default: 13,
    },
    disabledType: {         // input 비활성화 여부
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labelVal: this.label,    // placeholder 용 데이터
    };
  },
  methods: {
    // 입력 필드에서 키를 뗄 때마다 호출되어 포맷 적용 및 이벤트 emit
    onInput(event) {
      // 입력값에 대해 번호 포맷 적용(숫자와 하이픈만 구성)
      let val = this.formatPhoneNumber(event.target.value, this.maxLen);

      // 부모 컴포넌트에 값 전달(양방향 바인딩용 이벤트)
      this.$emit("input", val);
      this.$emit("inputNum", val);
    },

    // 숫자만 추출 후 전화번호 형식에 맞게 대시(-) 추가
    formatPhoneNumber(val, maxLen) {
      val = val.replace(/[^\d]/g, "");  // 숫자외 문자 모두 제거

      if (maxLen <= 4) {                // maxLen 아주 짧으면 그냥 반환
        return val;
      }
      if (val.length < 4)               // 3자리 이하 입력은 그대로 반환
        return val;
      if (val.length < 7)               // 4~6자리: 3-나머지 형태 예: 010-123
        return `${val.slice(0, 3)}-${val.slice(3)}`;
      if (val.length < 11)              // 7~10자리: 3-4-나머지 형태 예: 010-1234-567
        return `${val.slice(0, 3)}-${val.slice(3, 7)}-${val.slice(7)}`;

      // 11자리 이상일 땐 3-4-4자리 고정 반환 (즉, 최대 길이 처리)
      return `${val.slice(0, 3)}-${val.slice(3, 7)}-${val.slice(7, 11)}`;
    },

    // input 이벤트로 숫자가 아닌 문자 제거 및 마킹 번호 타입일 경우 1~99 범위 제한
    numberChk(event) {
      // 숫자만 남김
      let inputVal = event.target.value.replace(/[^0-9]/g, '');

      if (this.type === 'markingNum') {
        const numericValue = parseInt(inputVal, 10);
        if (numericValue < 1) {
          inputVal = '1';
        } else if (numericValue > 99) {
          inputVal = '99';
        }
      }

      // 필드 값 직접 수정
      event.target.value = inputVal;
    },
  },
};
</script>
